module.exports = __webpack_public_path__ + "img/point_box.0eaaca84.png";